/*! @pentacode/ui v0.1.0 */
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/tooltip-placement.js
var e = [
	"top",
	"bottom",
	"right",
	"left"
];
function t(t, a, o, s, c) {
	let l = c !== void 0 && Number.isFinite(c) ? Math.max(0, c) : 10, u = o.left + 8, d = o.top + 8, f = Math.max(u, o.right - 8 - a.width), p = Math.max(d, o.bottom - 8 - a.height), m = (s === void 0 || s === "auto" ? e : Array.isArray(s) ? s.length ? s : e : [s]).map((e) => n(e, t.x, t.y, a.width, a.height, l)), h = m[0], g = r(h, a.width, a.height, o, 8);
	for (let e of m) {
		let t = r(e, a.width, a.height, o, 8);
		if (t === 0) {
			h = e;
			break;
		}
		t < g && (h = e, g = t);
	}
	return {
		left: i(h.left, u, f),
		top: i(h.top, d, p),
		placement: h.placement
	};
}
function n(e, t, n, r, i, a) {
	let o = e.endsWith("right") || e === "right" ? 1 : e.endsWith("left") || e === "left" ? -1 : 0, s = e.startsWith("bottom") || e === "bottom" ? 1 : e.startsWith("top") || e === "top" ? -1 : 0;
	return {
		placement: e,
		left: t + (o - 1) * r / 2 + o * a,
		top: n + (s - 1) * i / 2 + s * a
	};
}
function r(e, t, n, r, i) {
	return Math.max(0, r.left + i - e.left) + Math.max(0, e.left + t + i - r.right) + Math.max(0, r.top + i - e.top) + Math.max(0, e.top + n + i - r.bottom);
}
function i(e, t, n) {
	return Math.max(t, Math.min(n, e));
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/tooltip-position.js
function a(e, n, r, i, a, o) {
	let s = e.offsetWidth, c = e.offsetHeight, l = t({
		x: n,
		y: r
	}, {
		width: s,
		height: c
	}, i, a, o);
	e.style.left = `${l.left}px`, e.style.top = `${l.top}px`, e.dataset.placement = l.placement;
}
function o(e, t, n, r) {
	let i = e.getBoundingClientRect();
	return !i.width || !i.height || !t || !n ? null : {
		x: i.left + r.x / t * i.width,
		y: i.top + r.y / n * i.height
	};
}
function s(e) {
	let t = e.defaultView, n = t?.visualViewport, r = n?.offsetLeft ?? 0, i = n?.offsetTop ?? 0, a = n?.width || e.documentElement.clientWidth || t?.innerWidth || 0, o = n?.height || e.documentElement.clientHeight || t?.innerHeight || 0;
	return {
		left: r,
		top: i,
		right: r + a,
		bottom: i + o
	};
}
function c(e, t) {
	return e.x >= t.left && e.x <= t.right && e.y >= t.top && e.y <= t.bottom;
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/tooltip-model.js
function l(e, t, n) {
	if (n === "focus") return [...e];
	if (typeof n == "function") return [...e].sort(n);
	if (n !== "color-domain") {
		let t = e[0], n = t !== void 0 && e.every((e) => w(e.xValue, t.xValue)), r = t !== void 0 && e.every((e) => w(e.yValue, t.yValue));
		return [...e].sort((e, t) => r && !n ? e.x - t.x || e.y - t.y : e.y - t.y || e.x - t.x);
	}
	return [...e].sort((e, n) => C(t, e.group) - C(t, n.group));
}
function u(e, t, n = !1, r, i) {
	let a = e[0];
	if (!a) return { rows: [] };
	let o = {
		...p(t, n, r),
		primaryPoint: i
	}, s = r?.content?.(e, o);
	if (s !== void 0) return s;
	let c = r?.formatGroup?.(e, o) ?? r?.format?.(i ?? a, o);
	return c === void 0 ? m(e, t, r, o) : c;
}
function d(e, t, n, r, i, a = {
	primary: e,
	group: t,
	source: "programmatic",
	pinned: !1
}) {
	let o = {
		x: e.x,
		y: e.y
	}, s = i?.anchor ?? "point";
	if (s === "point") return o;
	if (s === "pointer") return r ?? o;
	if (s === "group-center") {
		let n = e.x, r = e.x, i = e.y, a = e.y;
		for (let e of t) n = Math.min(n, e.x), r = Math.max(r, e.x), i = Math.min(i, e.y), a = Math.max(a, e.y);
		return {
			x: (n + r) / 2,
			y: (i + a) / 2
		};
	}
	if (typeof s == "object") return {
		x: S("x", s.x, e, t, n, r, o.x),
		y: S("y", s.y, e, t, n, r, o.y)
	};
	let c = s(t, {
		focus: a,
		pointer: r,
		plot: n.chart,
		surface: {
			width: n.width,
			height: n.height
		},
		scales: n.scales
	});
	return c && Number.isFinite(c.x) && Number.isFinite(c.y) ? c : o;
}
function f(e) {
	return e instanceof Date ? Number.isNaN(+e) ? "Invalid Date" : e.toISOString().replace("T00:00:00.000Z", "") : typeof e == "number" ? e.toLocaleString() : String(e);
}
function p(e, t, n) {
	let r = g(n?.items, "x"), i = g(n?.items, "y");
	return {
		pinned: t,
		xLabel: r?.label ?? x(e, "x-label") ?? "x",
		yLabel: i?.label ?? x(e, "y-label") ?? "y",
		formatX: f,
		formatY: f
	};
}
function m(e, t, n, r) {
	let i = e[0];
	if (!i) return { rows: [] };
	let a = g(n?.items, "x"), o = g(n?.items, "y"), s = g(n?.items, "group"), c = e.length > 1 && e.every((e) => w(e.xValue, i.xValue)), l = e.length > 1 && e.every((e) => w(e.yValue, i.yValue));
	if (c || l) {
		let n = c ? "x" : "y", l = c ? a : o, u = l?.label ?? x(t, `${n}-label`), d = b(i, n, l, r);
		return {
			title: u ? `${u}: ${d}` : d,
			rows: e.map((e) => ({
				label: y(e, s, r),
				value: b(e, c ? "y" : "x", c ? o : a, r),
				color: e.color,
				active: e === r.primaryPoint
			}))
		};
	}
	if (e.length > 1) return { rows: e.map((e) => ({
		label: y(e, s, r),
		value: `${b(e, "x", a, r)} \xB7 ${b(e, "y", o, r)}`,
		color: e.color,
		active: e === r.primaryPoint
	})) };
	let u = n?.items;
	return {
		title: i.group == null || u?.some(v) ? void 0 : y(i, s, r),
		color: i.group == null || u?.some(v) ? void 0 : i.color,
		rows: u ? h(i, u, r) : [{
			label: r.xLabel,
			value: b(i, "x", a, r)
		}, {
			label: r.yLabel,
			value: b(i, "y", o, r)
		}]
	};
}
function h(e, t, n) {
	return t.flatMap((t) => {
		if (typeof t == "string") return t === "group" ? [{
			label: "Group",
			value: e.groupLabel,
			color: e.color
		}] : [{
			label: t === "x" ? n.xLabel : n.yLabel,
			value: b(e, t, void 0, n)
		}];
		if ("channel" in t) {
			let r = t.text?.(e, n);
			return t.text && r == null ? [] : t.channel === "group" ? [{
				label: t.label ?? "Group",
				value: r ?? e.groupLabel,
				color: e.color
			}] : [{
				label: t.label ?? (t.channel === "x" ? n.xLabel : n.yLabel),
				value: r ?? b(e, t.channel, void 0, n)
			}];
		}
		if ("field" in t) {
			let r = e.datum[t.field];
			if (r == null) return [];
			let i = t.text?.(e, n);
			return t.text && i == null ? [] : [{
				label: t.label ?? t.field,
				value: i ?? f(r)
			}];
		}
		let r = t.text(e, n);
		return r == null ? [] : [{
			label: t.label ?? t.id,
			value: r
		}];
	});
}
function g(e, t) {
	let n = e?.find((e) => _(e) === t);
	return typeof n == "object" && "channel" in n ? n : void 0;
}
function _(e) {
	return typeof e == "string" ? e : "channel" in e ? e.channel : void 0;
}
function v(e) {
	return _(e) === "group";
}
function y(e, t, n) {
	return t?.text?.(e, n) ?? e.groupLabel;
}
function b(e, t, n, r) {
	let i = n?.text?.(e, r);
	if (i != null) return i;
	let a = t === "x" ? e.x1Value : e.y1Value, o = t === "x" ? e.x2Value : e.y2Value, s = t === "x" ? e.xInterval : e.yInterval;
	return s === "difference" && typeof a == "number" && typeof o == "number" ? f(o - a) : s === "range" && a !== void 0 && o !== void 0 && !w(a, o) ? `${f(a)}\u2013${f(o)}` : f(t === "x" ? e.xValue : e.yValue);
}
function x(e, t) {
	let n = e.nodes.find((e) => e.kind === "group" && e.key === "axes");
	if (n?.kind !== "group") return;
	let r = n.children.find((e) => e.key === t);
	return r?.kind === "label" ? r.text : void 0;
}
function S(e, t, n, r, i, a, o) {
	if (t === "point") return e === "x" ? n.x : n.y;
	if (t === "pointer") return a?.[e] ?? o;
	if (t === "value") {
		let t = e === "x" ? n.xValue : n.yValue, r = i.scales[e], a = (r?.viewport?.map ?? r?.map)?.(t);
		return a !== void 0 && Number.isFinite(a) ? a : o;
	}
	if (t === "group-center") {
		let t = e === "x" ? n.x : n.y, i = t;
		for (let n of r) {
			let r = e === "x" ? n.x : n.y;
			t = Math.min(t, r), i = Math.max(i, r);
		}
		return (t + i) / 2;
	}
	let s = i.chart;
	if (e === "x") {
		if (t === "plot-left") return s.x;
		if (t === "plot-center") return s.x + s.width / 2;
		if (t === "plot-right") return s.x + s.width;
	} else {
		if (t === "plot-top") return s.y;
		if (t === "plot-center") return s.y + s.height / 2;
		if (t === "plot-bottom") return s.y + s.height;
	}
	return o;
}
function C(e, t) {
	let n = t == null ? -1 : e.colors.domain.indexOf(t);
	return n < 0 ? 2 ** 53 - 1 : n;
}
function w(e, t) {
	return e instanceof Date && t instanceof Date ? e.getTime() === t.getTime() : Object.is(e, t);
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/tooltip.js
var T = {
	id: "tooltip",
	__chartExtensionType: "tooltip",
	__chartTooltipHost: "dom",
	create: E
};
function E(e) {
	let t = {}, n, r, i, o = !1, s = !1, c, f = [], p = !1, m = !1, h, g = null, _, v, y, b, { container: x } = e, S = x.ownerDocument.defaultView, C = e.motion;
	function w(e) {
		t !== e && (m = !0), t = e, n && R();
	}
	function T(e) {
		if (h?.point !== e.point && (m = !0), h = e, t.visibility === "pinned" && !e.pinned) {
			U();
			return;
		}
		let n = E();
		R();
		let r = C?.beforePaint(n);
		n.style.visibility = "hidden", n.removeAttribute("hidden"), n.className = t.className ? `ts-chart-tooltip ${t.className}` : "ts-chart-tooltip";
		let i = l(e.points, e.scene, t.sort), a = u(i, e.scene, e.pinned, t, e.point), o = B(n, i, a, e.pinned);
		o !== s && (Object.assign(n.style, o ? O : k), s = o), o || (typeof a == "string" ? j(n, a) : M(n, a)), P(n, a, o, e.pinned), n.style.pointerEvents = e.pinned ? "auto" : "none", n.style.userSelect = e.pinned ? "text" : "none", n.dataset.sticky = String(e.pinned), g = d(e.point, i, e.scene, e.pointer, t, e.focus), L(), n.style.removeProperty("visibility"), r && C?.afterPaint(n, r, t.motion);
	}
	function E() {
		return n || (n = A(x.ownerDocument), n.addEventListener("keydown", F), v = S?.ResizeObserver ? new S.ResizeObserver(I) : void 0, v?.observe(n), x.append(n), n);
	}
	function F(t) {
		t.key === "Escape" && h?.pinned && (t.preventDefault(), t.stopPropagation(), e.dismiss());
	}
	function I() {
		h && g && _ === void 0 && (S?.requestAnimationFrame ? _ = S.requestAnimationFrame(() => {
			_ = void 0, L();
		}) : L());
	}
	function L() {
		h && n && g && (b ? b.position({
			scene: h.scene,
			surface: h.surface,
			anchor: g,
			placement: t.placement,
			offset: t.offset
		}) || n.setAttribute("hidden", "") : a(n, g.x, g.y, {
			left: 0,
			top: 0,
			right: h.scene.width,
			bottom: h.scene.height
		}, t.placement, t.offset));
	}
	function R() {
		if (!n) return;
		let e = t.portal, r = e ? "create" in e ? e : e.use : void 0, i = e && "use" in e ? e : {};
		r === y ? b?.update(i) : (b?.destroy(), b = void 0, y = r, r ? b = r.create({
			container: x,
			element: n,
			schedulePosition: I
		}, i) : z());
	}
	function z() {
		n && (n.parentNode !== x && x.append(n), n.removeAttribute("popover"), delete n.dataset.tsChartTooltipPortal, Object.assign(n.style, {
			position: "absolute",
			zIndex: "1",
			right: "auto",
			bottom: "auto",
			margin: "0"
		}));
	}
	function B(t, n, a, s) {
		let l = e.bodyChange();
		if (!l) return H(), !1;
		i !== l && (i?.(null), i = l, o = !1, r = void 0), r || (r = t.ownerDocument.createElement("div"), r.className = "ts-chart-tooltip__body", t.replaceChildren(r)), r.toggleAttribute("inert", !s), N(t, a);
		let u = m || !o || c !== h?.scene || p !== s || !D(n, f);
		return m = !1, o = !0, c = h?.scene, f = n, p = s, u && l({
			element: r,
			primaryPoint: h?.point,
			points: n,
			content: a,
			pinned: s,
			dismiss: e.dismiss
		}), !0;
	}
	function V() {
		o && (o = !1, i?.(null));
	}
	function H() {
		V(), i = void 0, r = void 0, c = void 0, f = [];
	}
	function U() {
		h = void 0, g = null;
		let e = n;
		if (!e || e.hidden) {
			b?.hide(), V();
			return;
		}
		let r = () => {
			b?.hide(), e.setAttribute("hidden", ""), V();
		};
		C?.hide(e, t.motion, r) || r();
	}
	function W() {
		U(), H(), b?.destroy(), b = void 0, y = void 0, _ !== void 0 && (S?.cancelAnimationFrame?.(_), _ = void 0), C?.destroy(n), v?.disconnect(), v = void 0, n?.remove(), n = void 0;
	}
	return {
		update: w,
		paint: T,
		hide: U,
		contains: (e) => !!(e && n?.contains(e)),
		destroy: W
	};
}
function D(e, t) {
	return e.length === t.length && e.every((e, n) => e.key === t[n]?.key && e.markId === t[n]?.markId && e.datumIndex === t[n]?.datumIndex);
}
var O = {
	maxWidth: "none",
	padding: "0",
	border: "none",
	borderRadius: "0",
	background: "transparent",
	color: "inherit",
	boxShadow: "none",
	font: "inherit"
}, k = {
	maxWidth: "var(--ts-chart-tooltip-max-width, min(24rem, 80%))",
	padding: "var(--ts-chart-tooltip-padding, 0.4rem 0.55rem)",
	border: "var(--ts-chart-tooltip-border, 1px solid color-mix(in srgb, CanvasText 18%, transparent))",
	borderRadius: "var(--ts-chart-tooltip-border-radius, 0.45rem)",
	background: "var(--ts-chart-tooltip-background, Canvas)",
	color: "var(--ts-chart-tooltip-color, CanvasText)",
	boxShadow: "var(--ts-chart-tooltip-shadow, 0 6px 24px rgb(0 0 0 / 0.14))",
	font: "var(--ts-chart-tooltip-font, 500 0.75rem/1.3 system-ui, sans-serif)"
};
function A(e) {
	let t = e.createElement("div");
	return t.className = "ts-chart-tooltip", t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), Object.assign(t.style, {
		position: "absolute",
		zIndex: "1",
		...k,
		pointerEvents: "none",
		overflowWrap: "anywhere"
	}), t.hidden = !0, t;
}
function j(e, t) {
	N(e, t), e.textContent = t;
}
function M(e, t) {
	let n = e.ownerDocument, r = [];
	if (t.title) {
		let e = n.createElement("div");
		e.className = "ts-chart-tooltip__title", e.style.cssText = `display:flex;align-items:center;gap:.4rem;font-weight:650;margin-bottom:${t.rows.length ? ".3rem" : "0"}`, t.color && e.append(F(n, t.color)), e.append(t.title), r.push(e);
	}
	if (t.rows.length) {
		let e = n.createElement("div");
		e.className = "ts-chart-tooltip__rows", e.setAttribute("aria-hidden", "true");
		for (let r of t.rows) {
			let t = n.createElement("div");
			t.className = "ts-chart-tooltip__row", t.style.cssText = "display:grid;grid-template-columns:.55rem minmax(0,1fr) auto;align-items:center;column-gap:.4rem", t.dataset.active = String(r.active === !0), r.active && (t.style.fontWeight = "var(--ts-chart-tooltip-active-row-font-weight, 700)", t.style.background = "var(--ts-chart-tooltip-active-row-background, color-mix(in srgb, currentColor 12%, transparent))", t.style.borderRadius = "var(--ts-chart-tooltip-active-row-border-radius, .2rem)", t.style.boxShadow = "var(--ts-chart-tooltip-active-row-shadow, 0 0 0 2px color-mix(in srgb, currentColor 12%, transparent))");
			let i = r.color ? F(n, r.color) : n.createElement("span"), a = n.createElement("span");
			a.textContent = r.label;
			let o = n.createElement("span");
			o.textContent = r.value, o.style.cssText = "text-align:right;font-variant-numeric:tabular-nums;white-space:nowrap", t.append(i, a, o), e.append(t);
		}
		r.push(e);
	}
	e.replaceChildren(...r), N(e, t);
}
function N(e, t) {
	typeof t == "string" ? (e.removeAttribute("aria-label"), e.style.whiteSpace = "pre-wrap") : (e.style.whiteSpace = "normal", e.setAttribute("aria-label", [t.title, ...t.rows.map((e) => `${e.label}: ${e.value}`)].filter(Boolean).join("\n")));
}
function P(e, t, n, r) {
	n && typeof t == "string" && e.setAttribute("aria-label", t), n && r ? (e.setAttribute("role", "dialog"), e.setAttribute("aria-modal", "false"), e.removeAttribute("aria-live")) : (e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.removeAttribute("aria-modal"), !n && typeof t == "string" && e.removeAttribute("aria-label"));
}
function F(e, t) {
	let n = e.createElement("span");
	return n.className = "ts-chart-tooltip__swatch", n.setAttribute("aria-hidden", "true"), n.style.cssText = "display:block;width:.55rem;height:.55rem;border-radius:.15rem;box-shadow:inset 0 0 0 1px rgb(0 0 0/.12)", n.style.background = t, n;
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/tooltip-portal.js
var I = {
	id: "portal",
	create: L
};
function L(e, t) {
	let n = !1, r = !1, i = !1, l = !1, u, d, { container: f, element: p } = e, m = f.ownerDocument, h = m.defaultView, g = h?.ResizeObserver ? new h.ResizeObserver(_) : void 0;
	g?.observe(p);
	function _() {
		d && u === void 0 && (h?.requestAnimationFrame ? u = h.requestAnimationFrame(() => {
			u = void 0, d && x(d);
		}) : x(d));
	}
	function v() {
		n || (n = !0, h?.addEventListener("scroll", _, {
			capture: !0,
			passive: !0
		}), h?.addEventListener("resize", _, { passive: !0 }), h?.visualViewport?.addEventListener("scroll", _, { passive: !0 }), h?.visualViewport?.addEventListener("resize", _, { passive: !0 }), g?.observe(f));
	}
	function y() {
		n && (n = !1, h?.removeEventListener("scroll", _, !0), h?.removeEventListener("resize", _), h?.visualViewport?.removeEventListener("scroll", _), h?.visualViewport?.removeEventListener("resize", _), g?.unobserve(f), u !== void 0 && (h?.cancelAnimationFrame?.(u), u = void 0));
	}
	function b() {
		typeof p.showPopover == "function" && !l ? (p.parentNode !== f && f.append(p), p.setAttribute("popover", "manual"), p.dataset.tsChartTooltipPortal = "popover", p.style.zIndex = "1", r = !0) : S(), Object.assign(p.style, {
			position: "fixed",
			right: "auto",
			bottom: "auto",
			margin: "0"
		});
	}
	function x(e) {
		d = e, v(), b();
		let t = o(e.surface.element, e.scene.width, e.scene.height, e.anchor), n = s(m);
		return !t || n.right <= n.left || n.bottom <= n.top || !c(t, n) ? (E(!1), !1) : (p.removeAttribute("hidden"), r && !C() && (l = !0, S()), a(p, t.x, t.y, n, e.placement, e.offset), !0);
	}
	function S() {
		w(), r = !1, p.removeAttribute("popover"), p.dataset.tsChartTooltipPortal = "fallback", p.style.zIndex = "2147483647";
		let e = m.body ?? m.documentElement;
		p.parentNode !== e && e.append(p);
	}
	function C() {
		if (!r) return !1;
		if (T()) return !0;
		try {
			return p.showPopover(), i = !0, !0;
		} catch {
			return i = !1, !1;
		}
	}
	function w() {
		if (r) {
			try {
				T() && p.hidePopover?.();
			} catch {}
			i = !1;
		}
	}
	function T() {
		if (!r) return !1;
		try {
			return p.matches(":popover-open");
		} catch {
			return i;
		}
	}
	function E(e = !0) {
		w(), p.setAttribute("hidden", ""), e && (d = void 0, y());
	}
	return b(), {
		update(e) {},
		position: x,
		hide: E,
		destroy() {
			d = void 0, y(), w(), g?.disconnect(), r = !1, i = !1, l = !1, p.removeAttribute("popover"), delete p.dataset.tsChartTooltipPortal;
		}
	};
}
// src/charts/theme.ts
var R = (e, t) => `var(--chart-series-${e}, var(--${t}))`, z = [
	R(1, "blue"),
	R(2, "green"),
	R(3, "orange"),
	R(4, "teal"),
	R(5, "violet"),
	R(6, "red"),
	R(7, "pink"),
	R(8, "grey")
], B = {
	positive: "var(--chart-positive, var(--color-positive))",
	negative: "var(--chart-negative, var(--color-negative))",
	axis: "var(--chart-axis, color-mix(in srgb, currentColor 60%, transparent))",
	grid: "var(--chart-grid, color-mix(in srgb, currentColor 12%, transparent))",
	track: "var(--chart-track, color-mix(in srgb, currentColor 12%, transparent))"
}, V = {
	palette: z,
	grid: B.grid,
	muted: B.axis
};
function H(e = {}) {
	return {
		...e,
		use: T,
		portal: I
	};
}
export { H as i, z as n, V as r, B as t };

//# sourceMappingURL=theme-BDdgxk0M.js.map